import {
  ShopActionTypes,
  FETCH_SHOP,
  FETCH_SHOP_TYPE,
  FETCH_SHOP_PRODUCT,
  LOADING_SHOP,
  ShopState,
  FETCH_TRACKING_SALE,
  LOADING_PRODUCT_BUTTONS,
  FETCH_MY_ORDERS,
  SET_LOGIN,
  RESET_SHOP,
} from "../actions/types";

const initialState: ShopState = {
  product_types: [],
  products: [],
  product: [],
  typesSizes: [],
  pathImages: [],
  isDisabledSite: false,
  isLoading: false,
  textPages: null,
  trackingSale: null,
  isLoadingProductButtons: false,
  myOrders: [],
  isLogued: false,
  lastPage: true,
};

export function shopReducer(
  state = initialState,
  action: ShopActionTypes
): ShopState {
  switch (action.type) {
    case FETCH_SHOP:
      return {
        ...state,
        product_types: action.payload.product_types,
        isDisabledSite: action.payload.isDisabledSite,
        isLoading: false,
        textPages: action.payload.text_pages,
      };
    case RESET_SHOP:
      return {
        ...state,
        isLoading: true,
        products: initialState.products,
      };

    case FETCH_SHOP_TYPE:
      return {
        ...state,
        products:
          action.payload.page === 1
            ? action.payload.products
            : [...state.products, ...action.payload.products],
        isLoading: false,
        lastPage: action.payload.last_page,
      };

    case FETCH_SHOP_PRODUCT:
      return {
        ...state,
        product: {
          ...state.product,
          [action.payload.product.id]: action.payload.product,
        },
        typesSizes: {
          ...state.typesSizes,
          [action.payload.product.id]: action.payload.typesSizes,
        },
        pathImages: {
          ...state.pathImages,
          [action.payload.product.id]: action.payload.pathImages,
        },
        isLoading: false,
        isLoadingProductButtons: false,
      };
    case FETCH_TRACKING_SALE:
      return {
        ...state,
        trackingSale: action.payload,
        isLoading: false,
      };

    case LOADING_SHOP:
      return {
        ...state,
        isLoading: true,
      };
    case LOADING_PRODUCT_BUTTONS:
      return {
        ...state,
        isLoadingProductButtons: true,
      };
    case FETCH_MY_ORDERS:
      return {
        ...state,
        myOrders: action.payload.myOrders,
        isLoading: false,
      };
    case SET_LOGIN:
      return {
        ...state,
        isLogued: action.payload.isLogued,
      };
    default:
      return state;
  }
}
